/* Bundle & Save box (snippets/bundle-offer.liquid).
   - Choosing a bar sets how many to buy; a hidden quantity field in the product form follows it.
   - The add-on rows are checkboxes; ticking one in a bar ticks it in every bar.
   - Add to cart sends the chosen number, the ticked add-ons and the free gift in one request, then refreshes and opens
     the theme's cart drawer (window.theme.refreshCart / openCart). If an add-on or the gift can't be added, it retries
     with the chosen number only, so the sale never fails because of an extra.
   - window.tpoPermalink() gives the choice as a cart link for the Apple Pay / Google Pay button under Add to cart
     (assets/tp-express.js). That button puts the choice in the cart before the shopper pays, so Add to cart first
     waits for it (window.tpxIdle) and adds nothing when the cart already holds exactly this choice. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  // the same choice, whatever the cart lines look like (a discount can split one variant into two lines)
  function keyOf(items) {
    var m = {};
    (items || []).forEach(function (l) { m[l.id] = (m[l.id] || 0) + l.quantity; });
    return Object.keys(m).sort().map(function (id) { return id + ':' + m[id]; }).join(',');
  }

  function cartHolds(base, items) {
    return fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        return !!c && c.item_count > 0 && keyOf(c.items.map(function (i) { return { id: i.variant_id, quantity: i.quantity }; })) === keyOf(items);
      })
      .catch(function () { return false; });
  }

  function init(root) {
    if (!root || root.__bo) return;
    root.__bo = true;

    var cfg = {};
    try { cfg = JSON.parse((root.querySelector('[data-bo-config]') || {}).textContent || '{}'); } catch (e) {}

    var info = root.closest('[data-product-info]') || document;
    var form = info.querySelector('form[data-product-form]');
    var qty = null;
    if (form) {
      qty = form.querySelector('input[name="quantity"]');
      if (!qty) {
        qty = document.createElement('input');
        qty.type = 'hidden';
        qty.name = 'quantity';
        qty.value = '1';
        form.appendChild(qty);
      }
    }

    function bars() { return Array.prototype.slice.call(root.querySelectorAll('[data-bo-bar]')); }
    function current() { return root.querySelector('[data-bo-bar].is-selected') || bars()[0]; }

    function select(bar, focus) {
      if (!bar) return;
      bars().forEach(function (b) {
        var on = b === bar;
        var radio = b.querySelector('[role="radio"]');
        b.classList.toggle('is-selected', on);
        if (radio) {
          radio.setAttribute('aria-checked', on ? 'true' : 'false');
          radio.tabIndex = on ? 0 : -1;
        }
      });
      if (qty) qty.value = bar.getAttribute('data-qty') || '1';
      if (focus) {
        var r = bar.querySelector('[role="radio"]');
        if (r) r.focus();
      }
      root.dispatchEvent(new CustomEvent('bundle:change', { bubbles: true, detail: { quantity: Number(bar.getAttribute('data-qty')) || 1 } }));
    }

    function toggle(row) {
      var on = row.getAttribute('aria-checked') !== 'true';
      var vid = row.getAttribute('data-vid');
      root.querySelectorAll('[data-bo-up][data-vid="' + vid + '"]').forEach(function (r) {
        r.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (event) {
      var row = event.target.closest('[data-bo-up]');
      if (row) {
        event.preventDefault();
        toggle(row);
        return;
      }
      var bar = event.target.closest('[data-bo-bar]');
      if (bar && !bar.classList.contains('is-selected')) select(bar);
    });

    root.addEventListener('keydown', function (event) {
      var radio = event.target.closest('[role="radio"]');
      if (!radio) return;
      var list = bars();
      var i = list.indexOf(radio.closest('[data-bo-bar]'));
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        select(list[(i + 1) % list.length], true);
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        select(list[(i - 1 + list.length) % list.length], true);
      } else if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        select(list[i], true);
      }
    });

    function lines() {
      var bar = current();
      var count = Number(bar && bar.getAttribute('data-qty')) || 1;
      var idField = form && form.querySelector('[name="id"]');
      var id = Number(idField && idField.value) || Number(cfg.variant);
      var main = { id: id, quantity: count };
      var extras = [];
      if (bar) {
        bar.querySelectorAll('[data-bo-up][aria-checked="true"]').forEach(function (r) {
          extras.push({ id: Number(r.getAttribute('data-vid')), quantity: 1 });
        });
      }
      if (cfg.gift) extras.push({ id: Number(cfg.gift), quantity: 1 });
      return { main: main, all: extras.reverse().concat([main]) };   // a cart shows one request's lines newest first: the product goes in last so it heads the cart
    }
    root.bundleLines = function () { return lines().all.slice(); };
    window.tpoPermalink = function () {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return base + 'cart/' + lines().all.map(function (l) { return l.id + ':' + l.quantity; }).join(',');
    };

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();          // the theme's own one-item handler listens on document
        var t = window.theme || {};
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var button = form.querySelector('[type="submit"]');
        var error = (form.closest('[data-product-info]') || form).querySelector('[data-form-error]');
        if (error) { error.hidden = true; error.textContent = ''; }
        if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }

        var picked = lines();
        var wallet = typeof window.tpxIdle === 'function';
        Promise.resolve(wallet ? window.tpxIdle() : null)
          .catch(function () {})
          .then(function () { return wallet ? cartHolds(base, picked.all) : false; })
          .then(function (already) {
            if (already) return null;                            // the wallet button already put this choice in the cart
            return post(base + 'cart/add.js', { items: picked.all })
              .catch(function (err) {
                if (picked.all.length > 1) return post(base + 'cart/add.js', { items: [picked.main] });
                throw err;
              });
          })
          .then(function () {
            if (typeof window.tpxCartChanged === 'function') window.tpxCartChanged();
            if (t.cartType === 'drawer' && typeof t.refreshCart === 'function' && document.getElementById('CartDrawer')) {
              return t.refreshCart().then(function () { if (typeof t.openCart === 'function') t.openCart(); });
            }
            window.location.href = (t.routes && t.routes.cart) || base + 'cart';
          })
          .catch(function (err) {
            if (!error) return;
            error.textContent = (err && (err.description || err.message)) || (t.strings && t.strings.error) || 'Something went wrong. Please try again.';
            error.hidden = false;
          })
          .then(function () {
            if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
          });
      });
    }

    select(current());
  }

  ready(function () {
    document.querySelectorAll('[data-bo]').forEach(init);
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bo]').forEach(init);
  });
})();
